/* eslint-disable react/no-danger */
import { makeStyles } from '@material-ui/styles';

import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    '& img': {
      display: 'block',
      maxWidth: '100%',
      margin: `${theme.spacing(4)} auto`,
    },
    '& p': {
      ...theme.typography.body1,
      marginBottom: theme.spacing(2),
    },
    '& a': { color: theme.palette.primary.main },
    '& ol': {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    '& ul': {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    '& li': {
      ...theme.typography.body1,
      marginLeft: theme.spacing(3),
    },
    '& h1': { ...theme.typography.h1, marginBottom: theme.spacing(3) },
    '& h2': { ...theme.typography.h2, marginBottom: theme.spacing(2) },
    '& h3': { ...theme.typography.h3, marginBottom: theme.spacing(1) },
    '& h4': theme.typography.h4,
    '& h5': theme.typography.h5,
    '& h6': theme.typography.h6,
    '& blockquote': {
      ...theme.typography.body1,
      borderLeft: `3px solid #ccc`,
      paddingLeft: theme.spacing(1),
    },
    '& .embed-youtube': {
      position: 'relative',
      width: '100%',
      paddingTop: '56.25%' /* 16:9 Aspect Ratio */,
    },
    '& .embed-youtube div': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100%',
    },
    '& iframe': {
      width: '100%',
      height: '100%',
    },
  },
}));

function WysiwygViewer(props) {
  const { value, children } = props;

  const classes = useStyles();

  if (children) return <div className={classes.root}>{children}</div>;

  return <div dangerouslySetInnerHTML={{ __html: value }} className={classes.root}></div>;
}

WysiwygViewer.propTypes = {
  value: PropTypes.any,
  children: PropTypes.any,
};

export default WysiwygViewer;
